module.exports = __webpack_public_path__ + "img/1487851493.258bc44f.jpg";